module.exports = __webpack_public_path__ + "img/trunk_8x2_z18.dfa71ef2.svg";